var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMore(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\xEB\x8D\x94\xEB\xB3\xB4\xEA\xB8\xB0"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 172",
    width: 11.8713,
    height: 11.8964,
    rx: 3,
    fill: "#977BFF"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 175",
    y: 14.1035,
    width: 11.8713,
    height: 11.8964,
    rx: 3,
    fill: "#977BFF"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 174",
    x: 14.1288,
    width: 11.8713,
    height: 11.8964,
    rx: 3,
    fill: "#977BFF"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 173",
    x: 14.1288,
    y: 14.1035,
    width: 11.8713,
    height: 11.8964,
    rx: 5.93563,
    fill: "#977BFF"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMore);
export default __webpack_public_path__ + "static/media/more.16a78f7cde493b66de4a7671dae9cd90.svg";
export { ForwardRef as ReactComponent };